import React from 'react';

import SectionMessage from '@atlaskit/section-message/message';

export default (): React.JSX.Element => (
	<SectionMessage appearance="success">
		<p>The file has been uploaded.</p>
	</SectionMessage>
);
